import Sidebar from '../components/sidebar';
import Recommendations from '../components/recs';
import Queue from '../components/queue';
import './styles.css';

function Home() {
  // const[loading, setLoading] = useState(false);

  // const fetchProfile = async () => {
  //   setLoading(true);
  //   try{
  //     const response = await fetch('https://api.spotify.com/v1/me', {
  //       headers: {
  //         Authorization: `Bearer YOUR_ACCESS_TOKEN`, // Replace with your token
  //       },
  //     });
  //   }
  // }

  return (
    <div id="flex-container">
      <Sidebar/>
      <Recommendations/>
      <Queue/>
    </div>
  );
}

export default Home;
